import axios, { CancelTokenSource } from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { IBookmarksSummary } from '../../../models/Bookmarks'
import BookmarksService from '../../../services/BookmarksService'
import Protected from '../../Protected'
import PageInfo from './PageInfo'
import { BOOKMARKSTYPES } from '../bookmarkstypes'
import useErrorHandler from '../../../hooks/useErrorHandler'
import FormErrorDisplay from '../../common/FormErrorMessages'
import Conditional from '../../common/Conditional'
import Loader from '../../common/Loader'
import '../Bookmarks.css'
import WorkplaceFooter from '../../common/WorkplaceFooter'
import { UserProfile } from '../../../models/Profile'
import ProfileService from '../../../services/ProfileService'
import { Button } from 'semantic-ui-react'
import { useHistory } from 'react-router-dom'
import { MainArticleLayout } from '../../../layouts/MainArticleLayout'

const Pages = () => {
  const [data, setData] = useState<IBookmarksSummary[]>([])
  const [hasMore, sethasMore] = useState(false)
  const mountedRef = useRef(false)
  const [isLoading, setIsLoading] = useState(true)
  const [userErrors, handleErrors] = useErrorHandler()
  const [isLoadingMore, setIsLoadingMore] = useState(false)
  const [userProfile, setUserProfile] = useState<UserProfile>()
  const { getCurrentUserProfile } = ProfileService
  const history = useHistory()
  const size = 10
  useEffect(() => {
    mountedRef.current = true
    const source = axios.CancelToken.source()
    fetchCurrentUserProfile(source)
      .then((profile) => {
        if (mountedRef.current) {
          setUserProfile(profile)
        }
      })
      .finally(() => {
        if (mountedRef.current) {
          setIsLoading(false)
        }
      })

    return () => {
      mountedRef.current = false
      if (source) {
        source.cancel('Operation cancelled')
      }
    }
  }, [])

  const fetchCurrentUserProfile = async (source: CancelTokenSource) => {
    return await getCurrentUserProfile(source).then((response) => {
      return response.result
    })
  }
  const getPages = async (source?: CancelTokenSource) => {
    await BookmarksService.getBookmarks(
      { offset: data.length, size: size },
      { type: BOOKMARKSTYPES.WEB },
      source
    ).then((response) => {
      if (mountedRef.current) {
        const res = response.result
        setData((old) => [...old, ...res.result])
        sethasMore(res.hasMore)
      }
    })
  }
  const loadMoreBookmarks = async () => {
    setIsLoadingMore(true)
    getPages()
      .then(() => {
        setIsLoadingMore(false)
      })
      .catch((error) => {
        setIsLoadingMore(false)
        handleErrors(error)
      })
  }

  useEffect(() => {
    mountedRef.current = true
    const source = axios.CancelToken.source()
    getPages(source)
      .then(() => {
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false)
        handleErrors(error)
      })

    return () => {
      mountedRef.current = false
      if (source) {
        source.cancel('Operation cancelled')
      }
    }
  }, [])

  const deleteBookmark = (id: string) => {
    history.push('/my-account/bookmarks-delete?id=' + id + '&type=pages')
  }
  return (
    <Protected>
      <MainArticleLayout>
        <Conditional if={isLoading}>
          <Loader />
        </Conditional>
        <div className="content-wrapper">
          <FormErrorDisplay
            show={userErrors?.length > 0}
            errorsList={userErrors}
          />
          <article className="main">
            <PageInfo />
            <Conditional if={data && data.length > 0}>
              <div className="table-wrapper">
                <table id="table-pages">
                  <thead>
                    <tr>
                      <th>Page name</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length > 0 &&
                      data.map((item, index) => (
                        <tr key={index} className="cell-color">
                          <td>
                            <a href={item.sourceUrl} target="blank">
                              {item.title} - &nbsp;
                              <i>
                                Bookmarked on&nbsp;
                                {item.createdOn}
                              </i>
                            </a>
                          </td>
                          <td className="float-right">
                            <Button
                              className="ui is-secondary button"
                              onClick={() => deleteBookmark(item.id)}
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <Conditional if={hasMore}>
                <button
                  onClick={loadMoreBookmarks}
                  className="button is-primary"
                  type="button"
                  disabled={isLoadingMore}
                >
                  Load more
                </button>
              </Conditional>
              <p>
                The information on your bookmarked pages updates automatically
                when we update information on our website.
              </p>
            </Conditional>

            <Conditional
              if={data.length <= 0 && !isLoading && userErrors?.length <= 0}
            >
              <p className="d-flex">You have no bookmarked pages.</p>
              <p></p>
            </Conditional>
          </article>
        </div>
        <p></p>
        <WorkplaceFooter userProfile={userProfile} isLoading={isLoading} />
      </MainArticleLayout>
    </Protected>
  )
}

export default Pages
